export default {
  city: (data, p) => ({
    header: `Запчасти спецтехника ${p.t(data.city)}`,
    header_uk: `Запчастини спецтехніка ${p.t(data.city)}`,

    title: `Запчасти спецтехника купить ${p.inCity} - Автобазар`,
    title_uk: `Запчастини спецтехніка купити ${p.inCity} - Автобазар`,

    description: `Купить запчасти спецтехника ${p.inCity}. Большой каталог запчастей спецтехника бу и новых на Автобазар с ценами и фото`,
    description_uk: `Купити запчастини спецтехніка ${p.inCity}. Великий каталог запчастин спецтехніка бу і нових на Автобазар з цінами і фото`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/templates.js